import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@emotion/react';

import moment from 'moment-timezone';

import { t } from 'services/translation';
import defaultImage from 'views/anyguide/tours/item/images/default_image.png';
import { createModalWithTrigger } from 'ui_system/modals/BaseModal';
import { timezoneList } from 'ui_system/select/timezone_select/timezoneList';

import {
  dateSelected,
  saveSchedule,
} from 'data_system/resource_portal/actions/experienceActions';
import {
  getSelectedDate,
  getExperienceById,
  getAvailableDates,
  isExperienceAvailabilityLoading,
  isSavingSchedule,
  getExperienceScheduleIsOnline,
  getResourceTimezone,
} from 'data_system/resource_portal/selectors';

import Schedule from './Schedule';

const ScheduleContainer = () => {
  const [startDateVisible, setStartDateVisible] = useState(false);
  const experience = useSelector(getExperienceById()) || {};
  const dateLabelText = t('DATE');
  const timeLabelText = t('TIME');
  const selectedDate = useSelector(getSelectedDate());
  const availableDates = useSelector(getAvailableDates()).map((d) =>
    moment(d, 'YYYYMMDD').format('YYYY-MM-DD')
  );
  const dispatch = useDispatch();
  const experienceAvailabilityLoading = useSelector(
    isExperienceAvailabilityLoading
  );
  const savingSchedule = useSelector(isSavingSchedule);
  const isOnline = useSelector(getExperienceScheduleIsOnline());
  const resourceTimezone = useSelector(getResourceTimezone);
  const timezone = timezoneList[resourceTimezone];
  const theme = useTheme();

  // Remove current date from availableDates if online
  const excludedDates = [];
  if (isOnline) {
    const currentDateTime = moment.tz(moment(), resourceTimezone);
    excludedDates.push(currentDateTime.format('YYYY-MM-DD'));
  }

  return (
    <Schedule
      startDateVisible={startDateVisible}
      setStartDateVisible={setStartDateVisible}
      dateLabelText={dateLabelText}
      timeLabelText={timeLabelText}
      selectedDate={selectedDate}
      availableDates={availableDates}
      excludedDates={excludedDates}
      logoUrl={defaultImage}
      name={experience.name}
      address={experience.address}
      loading={experienceAvailabilityLoading || savingSchedule}
      startDateToggled={() => {}}
      setDate={(d) => dispatch(dateSelected(moment(d).format('YYYYMMDD')))}
      setFieldValue={() => {}}
      timeSelectorToggled={() => {}}
      submit={() => dispatch(saveSchedule())}
      isOnline={experience.isOnline}
      timezone={experience.isOnline && timezone.name}
      brandColor={theme.brandColor}
    />
  );
};

export const ScheduleContainerModal = createModalWithTrigger(ScheduleContainer);
